import { useTranslation } from '../../hooks/useTranslation';

export default function SkipToMain() {
	const { t } = useTranslation();

	const handleClick = (event) => {
		event.preventDefault();
		const main = document.getElementById('main-content');
		if (!main) {
			return;
		}
		main.focus({ preventScroll: true });
		main.scrollIntoView();
	};

	return (
		<a href="#main-content" className="skip-link" onClick={handleClick}>
			{t('common.messages.skipToMainContent')}
		</a>
	);
}
